import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface FormInputContainerProps {
  required: boolean;
  label?: string;
  errorMessage?: string | null | undefined;
  children: ReactNode;
  hidden?: boolean;
}

const StyledInputWrapper = styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  flex-direction: column;
  gap: 0.4rem;

  input {
    border: 1px solid ${({ theme }) => theme?.palette?.stroke};
    height: 40px;
    padding: 0 16px;
    border-radius: ${({ theme }) => theme?.radius?.small};
    outline: none;
    width: 100%;
  }

  &.error {
    input {
      border: 1px solid red;
    }
  }

  .error-message {
    color: red;
    font-size: 0.9rem;
    margin: 0;
  }

  .required {
    &:after {
      content: ' *';
    }
  }
`;
export const FormInputWrapper: FC<FormInputContainerProps> = ({ required, label, errorMessage, children, hidden }) => {
  return (
    <StyledInputWrapper className={classNames({ error: errorMessage })} hidden={hidden}>
      {label && <label className={classNames({ required: required })}>{label}</label>}
      {children}
      <p className="error-message">{errorMessage || '\u00A0'}</p>
    </StyledInputWrapper>
  );
};
